function initLogosSwiper() {
	if (typeof Swiper === "undefined") {
		return;
	}

	const logosSwiperEl = document.querySelector(".logosSwiper");
	if (!logosSwiperEl) {
		return;
	}

	const motionPreference = window.matchMedia("(prefers-reduced-motion: reduce)");
	let logosSwiper = null;

	const createLogosSwiper = () => {
		logosSwiper?.destroy(true, true);
		const reduceMotion = motionPreference.matches;

		logosSwiper = new Swiper(logosSwiperEl, {
			slidesPerView: 2,
			spaceBetween: 24,
			loop: !reduceMotion,
			speed: reduceMotion ? 0 : 4000,
			autoplay: reduceMotion ? false : {
				delay: 0,
				disableOnInteraction: false,
			},
			allowTouchMove: reduceMotion,
			breakpoints: {
				480: { slidesPerView: 3, spaceBetween: 32 },
				768: { slidesPerView: 4, spaceBetween: 60 },
				980: { slidesPerView: 5, spaceBetween: 60 },
				1280: { slidesPerView: 6, spaceBetween: 60 },
			},
		});
	};

	createLogosSwiper();
	motionPreference.addEventListener("change", createLogosSwiper);
}

initLogosSwiper();

function initProjectsSwipers() {
	if (typeof Swiper === "undefined") return;

	const featuredEl = document.querySelector(".featuredProjectsSwiper");
	if (featuredEl) {
		new Swiper(featuredEl, {
			slidesPerView: 1,
			spaceBetween: 24,
			speed: 700,
			navigation: { nextEl: ".featured-projects-next", prevEl: ".featured-projects-prev" },
		});
	}

	const projectsEl = document.querySelector(".projectsSwiper");
	if (!projectsEl) return;

	new Swiper(projectsEl, {
		slidesPerView: "auto",
		spaceBetween: 20,
		loop: false,
		rewind: true,
		speed: 700,
		watchSlidesProgress: true,
		navigation: { nextEl: ".projects-next", prevEl: ".projects-prev" },
		breakpoints: { 0: { spaceBetween: 12 }, 581: { spaceBetween: 20 } },
	});
}

initProjectsSwipers();

function initPortfolioServicesSwiper() {
	if (typeof Swiper === "undefined") return;

	const portfolioSliders = document.querySelectorAll(".portfolioServicesSwiper");
	if (!portfolioSliders.length) return;

	portfolioSliders.forEach((portfolioEl) => {
		const section = portfolioEl.closest("section");
		const nextButton = section?.querySelector(".portfolio-services-next");
		const prevButton = section?.querySelector(".portfolio-services-prev");

		new Swiper(portfolioEl, {
			slidesPerView: "auto",
			spaceBetween: 20,
			loop: false,
			rewind: true,
			speed: 700,
			grabCursor: true,
			watchSlidesProgress: true,
			navigation: { nextEl: nextButton, prevEl: prevButton },
		});
	});
}

initPortfolioServicesSwiper();

function initArticlesSwiper() {
	if (typeof Swiper === "undefined") return;
	const articlesEl = document.querySelector(".articlesSwiper");
	if (!articlesEl) return;

	const section = articlesEl.closest("#articles");
	const nextButton = section?.querySelector(".articles-next");
	const prevButton = section?.querySelector(".articles-prev");

	new Swiper(articlesEl, {
		slidesPerView: 1.1,
		spaceBetween: 12,
		speed: 700,
		
		grabCursor: true,
		watchOverflow: false,
		watchSlidesProgress: true,
		navigation: { nextEl: nextButton, prevEl: prevButton },
		breakpoints: { 
			560: { slidesPerView: 1.2, spaceBetween: 20 }, 
			860: { slidesPerView: 1.8, spaceBetween: 20 },
			980: { slidesPerView: 1.3, spaceBetween: 20 }, 
			1180: { slidesPerView: 1.6, spaceBetween: 20 }, 
			1800: { slidesPerView: 2, spaceBetween: 20 }, 
			1921: { slidesPerView: 2.2, spaceBetween: 20 },
			2100: { slidesPerView: 2.5, spaceBetween: 20 } 
		},
	});
}

initArticlesSwiper();

function initServicesInternalSwiper() {
	if (typeof Swiper === "undefined") return;

	const servicesEl = document.querySelector(".servicesInternalSwiper");
	if (!servicesEl) return;

	const section = servicesEl.closest("#servicesInternal");
	const nextButton = section?.querySelector(".services-internal-next");
	const prevButton = section?.querySelector(".services-internal-prev");
	const thumbsEl = section?.querySelector(".servicesInternalThumbs");
	let thumbsSwiper = null;

	const scrollToServicesSlider = () => {
		const header = document.querySelector("header");
		const headerHeight = header ? header.offsetHeight : 0;
		const sectionOffset = 32;
		const sliderTop = servicesEl.getBoundingClientRect().top + window.scrollY;

		window.scrollTo({
			top: Math.max(0, sliderTop - headerHeight + sectionOffset),
			behavior: "smooth",
		});
	};

	if (thumbsEl) {
		thumbsSwiper = new Swiper(thumbsEl, {
			slidesPerView: 1.15,
			spaceBetween: 14,
			speed: 600,
			watchSlidesProgress: true,
			slideToClickedSlide: true,
			breakpoints: {
				581: { slidesPerView: 2, spaceBetween: 18 },
				981: { slidesPerView: 3, spaceBetween: 20, grid: { rows: 2, fill: "row" } },
			},
		});

		const showNextThumbAfterEdgeClick = (thumb) => {
			if (!thumbsSwiper || window.matchMedia("(min-width: 981px)").matches) {
				return;
			}

			const clickedIndex = Array.prototype.indexOf.call(thumbsSwiper.slides, thumb);
			const slidesPerView = Number(thumbsSwiper.params.slidesPerView) || 1;
			const visibleEndIndex = thumbsSwiper.activeIndex + Math.ceil(slidesPerView) - 1;
			const nextIndex = clickedIndex + 1;

			if (clickedIndex >= visibleEndIndex && nextIndex < thumbsSwiper.slides.length) {
				thumbsSwiper.slideTo(nextIndex);
			}
		};

		thumbsEl.addEventListener("click", (event) => {
			if (!(event.target instanceof Element)) {
				return;
			}

			const thumb = event.target.closest(".service-internal-thumb");

			if (!thumb) {
				return;
			}

			requestAnimationFrame(() => {
				showNextThumbAfterEdgeClick(thumb);
				scrollToServicesSlider();
			});
		});
	}

	new Swiper(servicesEl, {
		on: {
			slideChangeTransitionStart(swiper) {
				const activeSlide = swiper.slides[swiper.activeIndex];

				if (typeof window.revealServicesInternalTopics === "function") {
					window.revealServicesInternalTopics(activeSlide, true);
				}
			},
		},
		slidesPerView: 1,
		spaceBetween: 18,
		speed: 700,
		grabCursor: true,
		watchOverflow: true,
		watchSlidesProgress: true,
		keyboard: { enabled: true, onlyInViewport: true },
		navigation: { nextEl: nextButton, prevEl: prevButton },
		thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
		breakpoints: {
			640: { spaceBetween: 22 },
			1180: { spaceBetween: 32 },
		},
	});
}

initServicesInternalSwiper();
function initImpactSwiper() {
	if (typeof Swiper === "undefined") return;

	const impactEl = document.querySelector(".impactSwiper");
	if (!impactEl) return;

	const section = impactEl.closest("#impact-slider");
	const nextButton = section?.querySelector(".impact-slider-next");
	const prevButton = section?.querySelector(".impact-slider-prev");
	const pagination = section?.querySelector(".impact-slider-pagination");

	new Swiper(impactEl, {
		slidesPerView: 1,
		speed: 700,
		watchOverflow: true,
		keyboard: { enabled: true, onlyInViewport: true },
		pagination: { el: pagination, clickable: true },
		navigation: { nextEl: nextButton, prevEl: prevButton },
	});
}

initImpactSwiper();

function initPortfolioEditorialSwiper() {
	if (typeof Swiper === "undefined") return;

	const editorialEl = document.querySelector(".portfolioEditorialSwiper");
	if (!editorialEl) return;

	const section = editorialEl.closest("#portfolioEditorial");
	const nextButton = section?.querySelector(".portfolio-editorial-next");
	const prevButton = section?.querySelector(".portfolio-editorial-prev");


	new Swiper(editorialEl, {
		slidesPerView: "auto",
		spaceBetween: 0,
		loop: false,
		centeredSlides: true,
		centeredSlidesBounds: true,
		speed: 700,
		grabCursor: true,
		watchOverflow: true,
		watchSlidesProgress: true,
		keyboard: { enabled: true, onlyInViewport: true },
		navigation: { nextEl: nextButton, prevEl: prevButton },
		on: {
			slideChangeTransitionStart(swiper) {
				const enteringClass = swiper.activeIndex > swiper.previousIndex
					? "portfolio-editorial-card--entering-next"
					: "portfolio-editorial-card--entering-prev";

				swiper.slides.forEach((slide) => {
					slide.classList.remove(
						"portfolio-editorial-card--entering-next",
						"portfolio-editorial-card--entering-prev",
					);
				});


				swiper.slides[swiper.activeIndex]?.classList.add(enteringClass);
			},
			slideChangeTransitionEnd(swiper) {
				swiper.slides.forEach((slide) => {
					slide.classList.remove(
						"portfolio-editorial-card--entering-next",
						"portfolio-editorial-card--entering-prev",
					);
				});
			},
		},
	});
}

initPortfolioEditorialSwiper();
